<button id="bee-back-button" mat-button type="button" color="primary" class="primary-border"
        (click)="goToPreviousPage()">
  <mat-icon svgIcon="reply"></mat-icon>
  <span>Volver</span>
</button>
